<template>
  <div class="personal">
    <Header msg='个人资料'/>
    <div style="height:0.44rem;"></div>

    <div class="personal-choose">
        <!-- 头像 -->
        <div class="per-line">
            <div class=" flex flex-j-c-sb flex-a-i-center">
                <span>头像</span>
                <div class="flex flex-j-c-e flex-a-i-center method-right">
                    <a href="javascript:;" class="file">
                      <!-- <img :src="testImg[0]" :class="testjudge[0] ? 'img-active':''"/> -->
                      <img class="choose-avatar" :src="pageData.avatar_url">
                      <input type="file" id="idd" @change="handleFiles(3, 'myFiles3')" ref="myFiles3"/>
                    </a>
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <!-- 昵称 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>昵称</span>
                <div class="flex flex-j-c-e flex-a-i-center method-right">
                    <input v-model="pageData.nickname" placeholder="未填写" />
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <!-- 姓名 -->
        <div class="per-line" v-if="pageData.true_name">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>姓名</span>
                <div class="flex flex-j-c-e flex-a-i-center">
                    <!-- <input v-model="pageData.true_name"/> -->
                    <span>{{pageData.true_name}}</span>
                </div>
            </div>
        </div>
        <!-- 性别 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>性别</span>
                <div class="flex flex-j-c-e flex-a-i-center method-right" @click="showPopup('sex')">
                    <span>{{pageData.sex}}</span>
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <!-- 出生日期 -->
        <div class="per-line">
            <div class=" flex flex-j-c-sb flex-a-i-center">
                <span>出生日期</span>
                <div class="flex flex-j-c-e flex-a-i-center">
                    <span>{{pageData.birthday || '未完善'}}</span>
                    <!-- <img class="right-icon" src="@/assets/right.png"> -->
                </div>
            </div>
        </div>
        <!-- 紧急联系人姓名 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>紧急联系人</span>
                <input type="text" placeholder="请输入紧急联系人姓名" v-model="pageData.critical_true_name"/>
            </div>
        </div>
        <!-- 紧急联系人手机号 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>联系人手机号</span>
                <input type="number" placeholder="请输入紧急联系人手机号" v-model="pageData.critical_mobile_phone" oninput="if(value.length > 11)value = value.slice(0, 11)"/>
            </div>
        </div>
        <!-- 毕业时间 -->
        <!-- <div class="per-line">
            <div class=" flex flex-j-c-sb flex-a-i-center">
                <span>毕业时间</span>
                <div class="flex flex-j-c-e flex-a-i-center method-right" @click="openPicker('graduation_time')">
                    <span>{{pageData.graduation_time || '未完善'}}</span>
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div> -->
    </div>

    <div class="personal-choose">
      <!-- 院校 -->
      <div class="per-line">
          <div class=" flex flex-j-c-sb">
              <span>院校</span>
              <div class="flex flex-j-c-e method-right" @click="showPopup('college')" v-if="canChange">
                  <span>{{pageData.first_name || '请选择'}}</span>
                  <img class="right-icon" src="@/assets/right.png">
              </div>
              <div class="flex flex-j-c-e" v-else>
                  <span>{{pageData.first_name}}</span>
              </div>
          </div>
      </div>
      <!-- 层次 -->
      <div class="per-line">
          <div class=" flex flex-j-c-sb">
              <span>层次</span>
              <div class="flex flex-j-c-e method-right" @click="showPopup('arrangement')" v-if="canChange">
                  <span>{{pageData.second_name||'请选择'}}</span>
                  <img class="right-icon" src="@/assets/right.png">
              </div>
              <div class="flex flex-j-c-e" v-else>
                <span>{{pageData.second_name}}</span>
              </div>
          </div>
      </div>
      <!-- 专业 -->
      <div class="per-line">
          <div class=" flex flex-j-c-sb">
              <span>专业</span>
              <div class="flex flex-j-c-e method-right" @click="showPopup('major')" v-if="canChange">
                  <span>{{pageData.major || '请选择'}}</span>
                  <img class="right-icon" src="@/assets/right.png">
              </div>
              <div class="flex flex-j-c-e" v-else>
                <span>{{pageData.major}}</span>
              </div>
          </div>
      </div>
      <!-- <div class="per-line">
          <div class=" flex flex-j-c-sb flex-a-i-center">
              <span>专业</span>
              <div class="flex flex-j-c-e flex-a-i-center method-right">
                  <input v-model="pageData.major" placeholder="未填写" />
                  <img class="right-icon" src="@/assets/right.png">
              </div>
          </div>
      </div> -->

    </div>

    <div class="personal-choose">
      <!-- 原学历 -->
        <div class="per-line">
            <div class=" flex flex-j-c-sb flex-a-i-center">
                <span>原学历</span>
                <div class="flex flex-j-c-e flex-a-i-center method-right" @click="showPopup('degree')">
                    <span>{{pageData.degree || '未完善'}}</span>
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <!-- 原毕业学校 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
              <!-- <i class="red-star">*</i> -->
                <span>原毕业学校</span>
                <input type="text" placeholder="请输入原毕业学校" v-model="pageData.origin_school"/>
            </div>
        </div>
        <!-- 原毕业时间 -->
        <div class="per-line">
            <div class=" flex flex-j-c-sb flex-a-i-center">
                <span>原毕业时间</span>
                <div class="flex flex-j-c-e flex-a-i-center method-right" @click="openPicker('origin_graduation_time')">
                    <span>{{pageData.origin_graduation_time || '未完善'}}</span>
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <!-- 原毕业专业 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>原毕业专业</span>
                <input type="text" placeholder="请输入原毕业专业" v-model="pageData.origin_major"/>
            </div>
        </div>
        <!-- 原毕业证编号 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>原毕业证编号</span>
                <input type="text" placeholder="请输入原毕业证编号" v-model="pageData.origin_graduation_certificate"/>
            </div>
        </div>
    </div>

    <div class="personal-card">
        <!-- 证件材料 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb">
                <span>证件材料</span>
                <div></div>
            </div>
        </div>
    </div>

    <div class="upload-box flex flex-j-c-sb">
      <div class="upload-item">
        <a href="javascript:;" class="file">
          <img :src="testImg[0]" :class="testjudge[0] ? 'img-active':''"/>
          <input type="file" id="ida" @change="handleFiles(0, 'myFiles0')" ref="myFiles0"/>
        </a>
        <p>身份证人像面</p>
      </div>
      <div class="upload-item">
        <a href="javascript:;" class="file">
          <img :src="testImg[1]" :class="testjudge[1] ? 'img-active':''"/>
          <input type="file" id="idb" @change="handleFiles(1, 'myFiles1')" ref="myFiles1"/>
        </a>
        <p>身份证国徽面</p>
      </div>
      <div class="upload-item">
        <a href="javascript:;" class="file">
          <img :src="testImg[2]" :class="testjudge[2] ? 'img-active':''"/>
          <input type="file" id="idc" @change="handleFiles(2, 'myFiles2')" ref="myFiles2"/>
        </a>
        <p>毕业证书</p>
      </div>
    </div>

    <mt-button @click.native="handleClick" size="large">提交</mt-button>
    <!-- <mt-datetime-picker
      ref="datepicker"
      type="date"
      :startDate="sDate"
      :endDate="eDate"
      v-model="pickerValue"
      @confirm="dateHandleConfirm">
    </mt-datetime-picker> -->

    <van-popup
      v-model="show"
      round
      position="bottom"
      lock-scroll
      get-container="#app">
      <van-datetime-picker
        v-model="pickerValue"
        type="date"
        :min-date="sDate"
        :max-date="eDate"
        @confirm="dateHandleConfirm"
        @cancel="show = false"
      />
    </van-popup>
    

    <!-- <mt-popup
      v-model="popupVisible"
      popup-transition="popup-fade"
      position="bottom"
      class="mint-popup">
      <mt-picker :slots="slots" :itemHeight="50" showToolbar ref="picker">
          <mt-header title="请选择">
              <mt-button slot="left" @click="popupVisible = false">取消</mt-button>
              <mt-button slot="right" @click="handleConfirm">确定</mt-button>
          </mt-header>
      </mt-picker>
    </mt-popup> -->
    <mt-popup
      v-model="popupVisible"
      popup-transition="popup-fade"
      position="bottom"
      class="mint-popup">
      <mt-picker :slots="slots" :valueKey="Indexes" :itemHeight="50" showToolbar ref="picker">
          <mt-header :title.sync="popupName">
              <mt-button slot="left" @click="popupVisible = false">取消</mt-button>
              <mt-button slot="right" @click="handleConfirm">确定</mt-button>
          </mt-header>
      </mt-picker>
    </mt-popup>

    <div class="isloading" v-if="isload">
      <div class="loader">
        <div class="loader-inner ball-scale">
          <div></div>
        </div>
      </div>
      <div class="loader-text">页面准备中，请稍后...</div>
    </div>

  </div>
</template>

<script>
import { DatetimePicker, Popup } from 'vant';
import Header from '@/components/Header.vue';
import {getPersonal, uploadImg, changePersonal, GetCollege, modityLink} from '@/api';
import { Toast } from 'mint-ui';

export default {
  name: 'Personal',
  components: {
    Header
  },
  data() {
    return {
      testImg: [require('@/assets/jia.png'), require('@/assets/jia.png'), require('@/assets/jia.png'), require('@/assets/jia.png')], // 相关证件上传默认图片
      testjudge: [false, false, false, false], // 判断是否已上传相关证件
      param: null, // 上传表单
      pageData: {avatar_url: require('@/assets/avatar.png')}, // 页面数据
      pickerValue: new Date(), // 时间值
      pickerType: 'birthday', // 时间选择器类型
      slots: [{
        flex: 1,
        values: ['男', '女', '保密'],
        className: 'slot1',
        textAlign: 'center'
      }], // 选择联动数据
      sDate: new Date('1970/01/01'), // 开始时间
      eDate: new Date(), // 结束时间
      show: false, // 是否显示日期选择器

      collegeData: [], // 院校数据
      popupVisible: false, // picker 显示/隐藏
      popupType: '', // 联动类型
      popupName: '', // 联动名称
      Indexes: 'name', // 联动索引
      titleType: {}, // 报读类型
      college: {}, // 校区
      arrangement: {}, // 层次
      major: {}, // 专业
      // sexData: {}, // 性别数据
      // degreeData: {} // 原专业数据
      canChange: false, // 判断是否可修改院校
      isload: true, // 页面加载中
    }
  },
  created() {
    this.personalMsg();
    // console.log(this._tools.reBirthday('输入您的身份证')) // 根据身份证号码返回生日
  },
  mounted () {
  },
  methods: {
    // 文件上传选择
    handleFiles(index, e) {
      if (this.$refs[e].files.length === 0) return false;
      const isLt1M = this.$refs[e].files[0].size / 1024 / 1024 < 1;
      // if (!isLt1M) {
      //   Toast({message: '上传图片大小不能超过 1MB!', className: 'iconfont icon-close'});
      //   return
      // }
      var windowURL = window.URL || window.webkitURL;
      if (this.$refs[e].files !== 0) {
        this.param = {'name': this.$refs[e].files[0]}
        uploadImg(this.param).then(res => {
          if (res.code === 0) {
            this.testjudge.splice(index, 1, true)
            this.testImg.splice(index, 1, windowURL.createObjectURL(this.$refs[e].files[0]))
            switch (index) {
              case 0:
                this.pageData.idcard_front = res.data.url
                break;
              case 1:
                this.pageData.idcard_back = res.data.url
                break;
              case 2:
                this.pageData.graduation_certificate_img = res.data.url
                break;
              case 3:
                this.pageData.avatar_url = res.data.url
                break;
              default:
                break;
            }
          } else {
            Toast({message: res.msg, className: 'iconfont icon-close'});
          }
        });
      }
      // console.log(this.testImg)
    },
    // 获取页面数据
    personalMsg() {
      getPersonal().then(res => {
        this.pageData = res.data.user_info;
        if (res.data.user_info.idcard_back || res.data.user_info.idcard_front || res.data.user_info.graduation_certificate_img) {
          if(res.data.user_info.idcard_front){
            this.testImg[0]=res.data.user_info.idcard_front;
          }
          if(res.data.user_info.idcard_back){
            this.testImg[1]=res.data.user_info.idcard_back;
          }
          if(res.data.user_info.graduation_certificate_img){
            this.testImg[2]=res.data.user_info.graduation_certificate_img;
          }
          // this.testImg = [res.data.user_info.idcard_front, res.data.user_info.idcard_back, res.data.user_info.graduation_certificate_img];
          this.testjudge = [true, true, true, false]
        }
        if (this.pageData.first_name === '待定') this.canChange = true;
        if(res.code !== 0) {
          Toast({message: '请稍后重试', className: 'iconfont icon-close'});
        } else {
          this.getColleges();
        }
      })
    },
    // 时间选择器
    openPicker(str) {
      var dateTime=new Date();
      dateTime=dateTime.setDate(dateTime.getFullYear()+6);
      dateTime=new Date(dateTime);
      switch (str) {
        case 'birthday':
          this.pickerValue = new Date(this.pageData.birthday.replace(/-/g, '/'));
          this.eDate = new Date();
          break;
        case 'graduation_time':
          this.pickerValue = new Date(this.pageData.graduation_time.replace(/-/g, '/'));
          this.eDate = dateTime;
          break;
        case 'origin_graduation_time':
          this.pickerValue = new Date(this.pageData.origin_graduation_time.replace(/-/g, '/'));
          this.eDate = dateTime;
          break;
        default:
          break;
      }
      this.pickerType = str;
      // this.$refs.datepicker.open();
      this.show = true;
    },
    // 时间选择器确认选择
    dateHandleConfirm() {
      switch (this.pickerType) {
        case 'birthday':
          this.pageData.birthday = this._tools.formatDate(this.pickerValue);
          break;
        case 'graduation_time':
          this.pageData.graduation_time = this._tools.formatDate(this.pickerValue);
          break;
        case 'origin_graduation_time':
          this.pageData.origin_graduation_time = this._tools.formatDate(this.pickerValue);
          break;
        default:
          break;
      }
      this.show = false;
    },
    // 选择选项
    showPopup(str) {
      let judge = true;
      switch (str) {
        case 'sex': // 性别
          if(this.popupType !== 'sex') {
            this.slots = [{flex: 1, values: [{name: '男',id: 1}, {name: '女',id: 0}, {name: '保密',id: 2}], className: 'slot1', textAlign: 'center'}];
            this.Indexes = 'name';
            this.popupName = '选择性别';
          }
          break;
        case 'degree': // 原学历
          if(this.popupType !== 'degree') {
            this.slots = [{flex: 1, values: [{name: '小学',id: 1}, {name: '初中',id: 2}, {name: '高中',id: 3}, {name: '大专',id: 4}], className: 'slot1', textAlign: 'center'}];
            this.Indexes = 'name';
            this.popupName = '选择原学历';
          }
          break;
        case 'college': // 院校
          if (this.collegeData.length === 0) {
            Toast({message: '暂无数据', className: 'iconfont icon-close'});
            judge = false;
          } 
          if(this.collegeData !== this.slots[0].values) {
            this.slots = [{flex: 1, values: this.collegeData, className: 'slot1', textAlign: 'center'}];
            this.Indexes = 'name';
            this.popupName = '选择院校';
          }
          break;
        case 'arrangement': // 层次
          if (!this.college.id) {
            Toast({message: '请选择院校', className: 'iconfont icon-close'});
            judge = false
          } else if (this.college.son.length === 0) {
            Toast({message: '暂无层次信息', className: 'iconfont icon-close'});
            judge = false
          } 
          if(this.college.son !== this.slots[0].values) {
            this.slots = [{flex: 1, values: this.college.son, className: 'slot1', textAlign: 'center'}];
            this.Indexes = 'name';
            this.popupName = '选择层次';
          }
          break;
        case 'major': // 专业
          if (!this.arrangement.id) {
            Toast({message: '请选择层次', className: 'iconfont icon-close'});
            judge = false
          } else {
            this.getModity(0);
            judge = false
          }
          break;
        default:
          Toast({message: '请稍后重试', className: 'iconfont icon-close'});
          judge = false
          break;
      }
      if (judge) {
        this.popupVisible = true;
        this.popupType = str;
      }
    },
    // 确定选项
    handleConfirm() {
      switch (this.popupType) {
        case 'sex':
          this.pageData.sex = this.$refs.picker.getValues()[0].name;
          // this.sexData = this.$refs.picker.getValues()[0];
          break;
        case 'degree':
          this.pageData.degree = this.$refs.picker.getValues()[0].name;
          // this.degreeData = this.$refs.picker.getValues()[0];
          break;
        case 'college':
          this.college = this.$refs.picker.getValues()[0]
          this.pageData.first_name = this.college.name;
          /** -----------------------重置----------------------------- */
          this.arrangement = {};
          this.pageData.second_name = '';
          this.major = {};
          this.pageData.major = '';
          /** -----------------------重置----------------------------- */
          break;
        case 'arrangement':
          this.arrangement = this.$refs.picker.getValues()[0]
          this.pageData.second_name = this.arrangement.name;
          /** -----------------------重置----------------------------- */
          this.major = {};
          this.pageData.major = '';
          /** -----------------------重置----------------------------- */
          break;
        case 'major':
          this.major = this.$refs.picker.getValues()[0];
          this.pageData.major = this.major.name;
          break;
        default:
          Toast({message: '请稍后重试', className: 'iconfont icon-close'});
          break;
      }
      this.popupVisible = false
    },
    // 院校联动
    getColleges() {
      GetCollege().then(res => {
        if (res.code === 0) {
          let colObj = {}
          res.data.map((item, index) => {
            if (Number(item.id) === 68) {
              colObj.item = item;
              colObj.index = index;
            }
            // 匹配院校。专业。层次
            if (item.name === this.pageData.first_name) {
              this.college = item;
              item.son.map(items => {
                if (items.name === this.pageData.second_name) {
                  this.arrangement = items;
                }
              })
            }
          })
          this.getModity(1);
          res.data.splice(colObj.index, 1);
          // res.data.push(colObj.item);
          this.collegeData = res.data;
        }
        this.isload = false;
      })
    },
    // 专业联动数据接口
    getModity(e) {
      let params = {
        first_cat_id: this.college.id, // 院校id
        second_cat_id: this.arrangement.id // 层次id
      }
      modityLink(params).then(res => {
        if (res.code === 0) {
          if (e === 1) {
            res.data.map(item => {
              if (item.name = this.pageData.major) {
                this.major = item;
              }
            })
            // this.major = res.data[0]
          } else {
            if(this.slots[0].values !== res.data) {
              this.slots = [{flex: 1, values: res.data, className: 'slot1', textAlign: 'center'}];
              this.popupType = 'major';
              this.popupName = '选择专业';
              this.Indexes = 'name';
            }
            this.popupVisible = true;
          }
        } else {
          Toast({message: res.msg, className: 'iconfont icon-close'});
        }
      })
    },
    // 提交更改
    handleClick() {
      let params = this._tools.deepClone(this.pageData), judge = true;
      // if (!params.origin_school) {
      //   Toast({ message: '请填写原毕业学校', duration: 1500 });
      //   judge = false;
      //   return false;
      // }
      // if (!params.origin_graduation_time) {
      //   Toast({ message: '请选择原毕业时间', duration: 1500 });
      //   judge = false;
      //   return false;
      // }
      // if (!params.origin_major) {
      //   Toast({ message: '请填写原毕业专业', duration: 1500 });
      //   judge = false;
      //   return false;
      // }
      // if (!params.origin_graduation_certificate) {
      //   Toast({ message: '请填写原毕业证书编号', duration: 1500 });
      //   judge = false;
      //   return false;
      // }
      // if (!this.testjudge[0] || !this.testjudge[1] || !this.testjudge[2]){
      //   Toast({ message: '请上传相关材料', duration: 1500 });
      //   judge = false;
      //   return false;
      // }
      switch (this.pageData.sex) {
        case '男':
          params.sex = 1
          break;
        case '女':
          params.sex = 0
          break;
        case '保密':
          params.sex = 2
          break;
        default:
          break;
      }
      switch (this.pageData.degree) {
        case '小学':
          params.degree = 1
          break;
        case '初中':
          params.degree = 2
          break;
        case '高中':
          params.degree= 3
          break;
        case '大专':
          params.degree= 4
          break;
        default:
          break;
      }

      if (!this.major.id) {
        Toast({message: '请选择专业', className: 'iconfont icon-close'});
        judge = false;
        return false;
      } else {
        params.first_cat_id = this.college.id;
        params.second_cat_id = this.arrangement.id;
        params.goods_id = this.major.id;
      }
      if (!this._tools.checkPhone(String(params.critical_mobile_phone))) {
        Toast({message: '请输入正确的手机号码', className: 'iconfont icon-close', duration: 1500});
        judge = false;
        return false;
      }

      // console.log(params);
      // return false;
      if (judge) {
        changePersonal(params).then(res => {
          if (res.code === 0) {
            Toast({message: '更新成功', duration: 2000});
            setTimeout(res => {
              this.$router.go(-1);
            }, 2000)
          } else {
            Toast({message: res.msg, className: 'iconfont icon-close', duration: 1500});
          }
        })
      }
    }
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
  .personal{
    min-height: 100vh;
    font-size: 0.15rem;
    input{
      height: 0.48rem;
    }
    .personal-choose{
        padding: 0 0.16rem;
        background-color: white;
        margin-top: 0.1rem;
        &>:last-child{
            border: none;
        }
        .choose-avatar{
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 50%;
        }
    }
    .personal-card{
        width: 100%;
        height: 0.44rem;
        padding: 0 0.16rem;
        .per-line{
            background: transparent;
        }
    }
    .upload-box{
      padding: 0.1rem 0.2rem;
      background: white;
      .upload-item{
        width: 30%;
        p{
          font-size: 0.12rem;
          color: #999999;
        }
      }
      .file {
          position: relative;
          display: inline-block;
          background: #F7F7F7;
          border: 1px dashed #7D7D7D;
          border-radius: 4px;
          overflow: hidden;
          color: #1E88C7;
          width: 100%;
          height: 0.8rem;
          img{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 0.28rem;
            height: 0.28rem;
          }
          .img-active{
            width: 100%;
            height: 100%;
          }
      }
      .file input {
          position: absolute;
          font-size: 100px;
          right: 0;
          top: 0;
          opacity: 0;
      }
    }
    .mint-button--large{
        width: 100%;
        border-radius: 0;
        margin: 0.1rem 0 0;
    }
    .mint-datetime{
      border-radius: 6px 6px 0 0;
    }
    .mint-popup{
      width: 100%;
      border-radius: 8px 8px 0 0;
    }
    .mint-popup /deep/ .picker{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: white;
        border-radius: 8px 8px 0 0;
        .mint-header{
            background: white;
            height: 0.5rem;
            padding: 0 0.16rem;
            font-size: 0.15rem;
            .is-left{
                color: #999999;
            }
            .is-right{
                color: #FABF01;
            }
        }
        .mint-header-title{
            font-size: 0.17rem;
            color: black;
        }
    }
    /deep/ .picker-selected{
      color: #FABF01;
    }
    /deep/ .mint-datetime-confirm{
      color: #FABF01;
    }
    /deep/ .mint-datetime-cancel{
      color: #999;
    }
    .file {
        position: relative;
        display: inline-block;
        background: #F7F7F7;
        overflow: hidden;
        color: #1E88C7;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        img{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 0.28rem;
          height: 0.28rem;
        }
        .img-active{
          width: 100%;
          height: 100%;
        }
    }
    .file input {
        position: absolute;
        font-size: 100px;
        right: 0;
        top: 0;
        opacity: 0;
    }
  }
  /deep/ .van-picker__cancel{
    color: #999;
  }
  /deep/ .van-picker__confirm{
    color: #FABF01;
  }
  /deep/ .van-picker-column__item--selected{
    color: #FABF01;
  }
  .isloading{
    z-index: 999;
    width: 100%;
    height: 100vh;
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    .loader-text{
      color: #279fcf;
    }
  }
</style> 

